import { SelectField } from '@prismicio/client';

interface MediaIconsProps {
  icon: SelectField<'Facebook' | 'X' | 'LinkedIn' | 'Copy link'>;
}

export const MediaIcons = ({ icon }: MediaIconsProps) => {
  switch (icon) {
    case 'Facebook':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M14.5073 0.500036L14.5081 0.500035C15.3974 0.498638 16.2862 0.538829 17.1719 0.620468V3.48403H15.5006C14.5789 3.48403 13.8874 3.70359 13.4556 4.23372C13.0437 4.73926 12.9678 5.41464 12.9678 6.06003V8.78402V9.28402H13.4678H16.9672L16.5603 12.556H13.4678H12.9678V13.056V23.5H9.71759V13.056V12.556H9.21759H6.17188V9.28402H9.21759H9.71759V8.78402V5.64003C9.71759 3.91422 10.224 2.64087 11.0425 1.80101C11.8603 0.961843 13.0436 0.500036 14.5073 0.500036Z"
            fill="#1D1D1F"
            stroke="#1D1D1F"
          />
        </svg>
      );
    case 'LinkedIn':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M4.643 1C4.29609 0.999738 3.95254 1.06782 3.63195 1.20036C3.31136 1.33291 3.02003 1.52731 2.77459 1.77247C2.52915 2.01763 2.33442 2.30874 2.20151 2.62918C2.06861 2.94961 2.00013 3.2931 2 3.64C2 5.1 3.183 6.31 4.64 6.31C6.099 6.31 7.283 5.1 7.283 3.642C7.28326 3.29514 7.21517 2.95163 7.08262 2.6311C6.95006 2.31057 6.75564 2.0193 6.51047 1.77395C6.2653 1.52859 5.97418 1.33395 5.65375 1.20115C5.33332 1.06835 4.98986 1 4.643 1ZM17.535 8C15.316 8 14.047 9.16 13.437 10.314H13.373V8.311H9V23H13.557V15.729C13.557 13.813 13.701 11.961 16.072 11.961C18.409 11.961 18.443 14.146 18.443 15.85V23H23V14.932C23 10.984 22.151 8 17.535 8ZM2.363 8.31V23H6.923V8.31H2.363Z"
            fill="#1D1D1F"
          />
        </svg>
      );
    case 'X':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M3.32016 2.87988L10.1442 12.8286L2.98828 21.1199H4.51359L10.8202 13.813L15.832 21.1199H20.6386L13.4977 10.7099L20.2561 2.87988H18.7317L12.8227 9.72551L8.12672 2.87988H3.32016Z"
            fill="#1D1D1F"
          />
        </svg>
      );
    case 'Copy link':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g clipPath="url(#clip0_3256_777)">
            <path
              d="M13.433 9.97477C12.4402 8.93487 11.1038 8.33447 9.7003 8.29777C8.29679 8.26107 6.93349 8.79087 5.89242 9.77758L5.69433 9.97477L2.59931 13.2181C1.59131 14.2759 1.01758 15.7042 1.0004 17.1987C0.983215 18.6932 1.52394 20.1357 2.50733 21.2186C3.49072 22.3015 4.83898 22.9392 6.26475 22.9959C7.69051 23.0525 9.08101 22.5236 10.1399 21.5218L10.3369 21.3246L12.6592 18.8918C12.8555 18.6855 12.9694 18.4087 12.9779 18.1175C12.9864 17.8264 12.8888 17.5428 12.7049 17.3243C12.521 17.1058 12.2646 16.9689 11.9878 16.9413C11.711 16.9136 11.4345 16.9974 11.2146 17.1756L11.1117 17.2708L8.78934 19.7035C8.18733 20.3378 7.37311 20.7015 6.51939 20.7174C5.66566 20.7333 4.83961 20.4002 4.21644 19.7887C3.59328 19.1772 3.22203 18.3355 3.18145 17.4421C3.14087 16.5486 3.43414 15.6738 3.99907 15.0031L4.14682 14.8391L7.24184 11.597C7.54672 11.2776 7.90869 11.0242 8.30707 10.8513C8.70545 10.6784 9.13243 10.5894 9.56365 10.5894C9.99486 10.5894 10.4218 10.6784 10.8202 10.8513C11.2186 11.0242 11.5806 11.2776 11.8855 11.597C12.0908 11.812 12.3693 11.9327 12.6596 11.9326C12.9499 11.9325 13.2283 11.8115 13.4335 11.5964C13.6387 11.3813 13.754 11.0896 13.7538 10.7855C13.7537 10.4814 13.6383 10.1897 13.433 9.97477ZM20.3978 2.67879C19.4051 1.63889 18.0687 1.03849 16.6652 1.00179C15.2617 0.965085 13.8984 1.49489 12.8573 2.4816L12.6592 2.67879L10.3379 5.11269C10.1417 5.31901 10.0277 5.59585 10.0192 5.88699C10.0107 6.17812 10.1084 6.46173 10.2923 6.68021C10.4762 6.89868 10.7325 7.03563 11.0093 7.06326C11.2861 7.09088 11.5626 7.00709 11.7826 6.82892L11.8855 6.73377L14.2067 4.30216C14.8098 3.67455 15.6217 3.31642 16.4717 3.30312C17.3217 3.28981 18.1435 3.62237 18.7641 4.23083C19.3848 4.83929 19.756 5.67622 19.7997 6.56554C19.8433 7.45485 19.556 8.32723 18.9981 8.99915L18.8503 9.16423L15.7542 12.4075C15.1385 13.0523 14.3036 13.4145 13.433 13.4145C12.5624 13.4145 11.7274 13.0523 11.1117 12.4075C11.0101 12.301 10.8894 12.2165 10.7567 12.1588C10.6239 12.1012 10.4815 12.0714 10.3378 12.0714C10.194 12.0713 10.0517 12.1009 9.91886 12.1585C9.78603 12.2161 9.66533 12.3005 9.56365 12.407C9.46196 12.5134 9.38129 12.6398 9.32623 12.7789C9.27117 12.918 9.24281 13.0671 9.24276 13.2177C9.24271 13.3682 9.27097 13.5174 9.32594 13.6565C9.3809 13.7956 9.46149 13.9221 9.5631 14.0286C10.5559 15.0685 11.8922 15.6689 13.2958 15.7056C14.6993 15.7423 16.0626 15.2125 17.1036 14.2258L17.3028 14.0286L20.3978 10.7853C21.4237 9.71036 22 8.2526 22 6.73262C22 5.21264 21.4237 3.75374 20.3978 2.67879Z"
              fill="#1D1D1F"
            />
          </g>
          <defs>
            <clipPath id="clip0_3256_777">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="matrix(-1 0 0 1 24 0)"
              />
            </clipPath>
          </defs>
        </svg>
      );

    default:
      return null;
  }
};
